import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { clsx } from 'clsx'
import type { RegisterFlow } from '../hooks/useRegisterFlow'
import styles from './EmailStep.module.css'

const emailSchema = z.object({
  email: z.string().email('E-mail inválido'),
})

type EmailForm = z.infer<typeof emailSchema>

type EmailStepProps = {
  flow: RegisterFlow
}

export function EmailStep({ flow }: EmailStepProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailForm>({
    resolver: zodResolver(emailSchema),
    mode: 'onBlur',
  })

  function handleSend(data: EmailForm) {
    void flow.sendOtp(data.email)
  }

  return (
    <div className={styles.step}>
      <h1 className={styles.heading}>Entre ou crie sua conta</h1>
      <p className={styles.sub}>Sem senha para lembrar. Código no e-mail, pronto.</p>

      {/* Email form */}
      <form onSubmit={handleSubmit(handleSend)} noValidate>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel} htmlFor="email">E-MAIL</label>
          <input
            id="email"
            className={clsx(styles.fieldInput, errors.email && styles.fieldInputError)}
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="voce@email.com"
            autoFocus
            disabled={flow.isLoading}
            {...register('email')}
          />
          {errors.email ? (
            <p className={styles.fieldError} role="alert">{errors.email.message}</p>
          ) : (
            <p className={styles.fieldHint}>Enviaremos um código de 6 dígitos. Sem spam.</p>
          )}
        </div>

        {flow.error && (
          <p className={styles.formError} role="alert">{flow.error}</p>
        )}

        <button
          type="submit"
          className={styles.btnPrimary}
          disabled={flow.isLoading}
        >
          {flow.isLoading ? 'Enviando…' : '✉ RECEBER CÓDIGO'}
        </button>
      </form>
    </div>
  )
}
